import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningIcon from '@mui/icons-material/Warning';

const Message = ({ text, type }) => {
  const theme = useTheme();

  const styles = {
    success: {
      backgroundColor: theme.palette.success.light,
      color: theme.palette.success.dark,
      border: `1px solid ${theme.palette.success.dark}`,
    },
    error: {
      backgroundColor: theme.palette.error.light,
      color: theme.palette.error.dark,
      border: `1px solid ${theme.palette.error.dark}`,
    },
    warning: {
      backgroundColor: theme.palette.warning.light,
      color: theme.palette.warning.dark,
      border: `1px solid ${theme.palette.warning.dark}`,
    },
  };

  return (
    <Box sx={{ 
      ...styles[type],
      p: 2,
      borderRadius: 1,
      mb: 3,
      display: 'flex',
      alignItems: 'center',
     }}>
      {type === 'success' && (
        <CheckCircleIcon
          sx={{
            color: theme.palette.success.main,
            mr: 1,
          }}
        />
      )}
      {type === 'error' && (
        <CancelIcon
          sx={{
            color: theme.palette.error.main,
            mr: 1,
          }}
        />
      )}
      {type === 'warning' && (
        <WarningIcon
          sx={{
            color: theme.palette.warning.main,
            mr: 1,
          }}
        />
      )}
      <Typography variant="body1">{text}</Typography>
    </Box>
  );
};

export default Message;
